var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCarRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KPI-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Ride-Final-Copy-4",
    transform: "translate(-675.000000, -302.000000)",
    fill: "#D32F2F"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_car-copy-2",
    transform: "translate(675.778425, 302.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0001,10 L2.0001,13 L4,13 L4,11 L16,11 L16,13 L18.0001,13 L18.0001,10 L15,10 L15,8 L18.0001,8 L18.0001,7.3263303 L17.5,7 L2.5,7 L2.0001,7.3263303 L2.0001,8 L5,8 L5,10 L2.0001,10 Z M4.2,5 L15.8,5 L14.6489734,2 L5.35122662,2 L4.2,5 Z M6,13 L6,15 L0.0001,15 L0.0001,6.2598697 L2.19815686,4.78482849 L4.12897338,0 L15.8712266,0 L17.8020431,4.78482849 L20.0001,6.2598697 L20.0001,15 L14,15 L14,13 L6,13 Z M7,10 L7,8 L13,8 L13,10 L7,10 Z",
    id: "shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarRed);
export default __webpack_public_path__ + "static/media/ico_car_red.07b2d18b8a109489c8990c6736497f3c.svg";
export { ForwardRef as ReactComponent };